import { getApiUrl } from './api';

export interface ThemeResponse {
  id: number;
  name: string;
  active: boolean;
  created_at: any | null;
  updated_at: any | null;
}

export interface ThemeUpdate {
  name: string;
}

// Get active theme
export const getActiveTheme = async (): Promise<ThemeResponse> => {
  const response = await fetch(`${getApiUrl()}/theme`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to get active theme: ${response.status}`);
  }

  return response.json();
};

// Get all themes (admin only)
export const getAllThemes = async (): Promise<ThemeResponse[]> => {
  const token = localStorage.getItem('auth_token');
  if (!token) {
    throw new Error('Authentication required');
  }

  const response = await fetch(`${getApiUrl()}/admin/themes`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to get themes: ${response.status}`);
  }

  return response.json();
};

// Create a new theme (admin only)
export const createTheme = async (theme: ThemeUpdate): Promise<ThemeResponse> => {
  const token = localStorage.getItem('auth_token');
  if (!token) {
    throw new Error('Authentication required');
  }

  const response = await fetch(`${getApiUrl()}/admin/theme`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(theme)
  });

  if (!response.ok) {
    throw new Error(`Failed to create theme: ${response.status}`);
  }

  return response.json();
};

// Update a theme (admin only)
export const updateTheme = async (themeId: number, theme: ThemeUpdate): Promise<ThemeResponse> => {
  const token = localStorage.getItem('auth_token');
  if (!token) {
    throw new Error('Authentication required');
  }

  const response = await fetch(`${getApiUrl()}/admin/theme/${themeId}`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(theme)
  });

  if (!response.ok) {
    throw new Error(`Failed to update theme: ${response.status}`);
  }

  return response.json();
};

// Delete a theme (admin only)
export const deleteTheme = async (themeId: number): Promise<void> => {
  const token = localStorage.getItem('auth_token');
  if (!token) {
    throw new Error('Authentication required');
  }

  const response = await fetch(`${getApiUrl()}/admin/theme/${themeId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to delete theme: ${response.status}`);
  }
};

// Activate a theme (admin only)
export const activateTheme = async (themeId: number): Promise<ThemeResponse> => {
  const token = localStorage.getItem('auth_token');
  if (!token) {
    throw new Error('Authentication required');
  }

  const response = await fetch(`${getApiUrl()}/admin/theme/${themeId}/activate`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to activate theme: ${response.status}`);
  }

  return response.json();
}; 